import { render, staticRenderFns } from "./EventAutomation.vue?vue&type=template&id=4b6c409b&scoped=true"
import script from "./EventAutomation.vue?vue&type=script&lang=js"
export * from "./EventAutomation.vue?vue&type=script&lang=js"
import style0 from "./EventAutomation.vue?vue&type=style&index=0&id=4b6c409b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6c409b",
  null
  
)

export default component.exports